import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { Expense, StudyExpense } from '../../models/study';

import { SiteService } from '../../services/site/site.service';

@Injectable()
export class ExpenseRepository {
    constructor(
        private client: HttpClient,
        private siteService: SiteService
    ) {}

    getAvailableExpenses: () => Observable<StudyExpense[]> = () => {
        return this.client
            .get<Expense[]>(`${this.siteService.getSiteBaseUrl()}/api/expenses`)
            .pipe(
                map((result) =>
                    result.map((expense) => <StudyExpense>{ ...expense, id: 0, expenseId: expense.id, active: false })
                )
            );
    };
}
